import { TransactionType } from 'types/embedded/transactionType';
import { getId } from 'utils';

const paymentList = ['payment', 'refund', 'chargeback', 'cancel'];
const payoutList = ['payout', 'cancel'];

const getTransactionTypesIds = (transactionTypes: TransactionType[], transactionsList: string[]) =>
  transactionTypes
    .filter((type) => transactionsList.includes(type.alias))
    .map((type) => getId(type.id));

export const getCommissionsFilter = (
  transactionTypes?: TransactionType[],
  direction?: string | null,
) => {
  if (!transactionTypes || !direction) {
    return null;
  }

  return direction?.includes('payment')
    ? getTransactionTypesIds(transactionTypes, paymentList)
    : getTransactionTypesIds(transactionTypes, payoutList);
};
